import { combineReducers } from 'redux';
import profileReducer from '../routes/Profile/reducers/profile';
import workoutPageReducer from '../routes/Workout/reducers/workoutPage';
import workoutReducer from './workout';
import workoutDataReducer from './workoutData';
import appStateReducer from './app';

export default function makeRootReducer(asyncReducers) {
  return combineReducers({
    profile: profileReducer,
    app: appStateReducer,
    workoutPage: workoutPageReducer,
    entities: combineReducers({
      workouts: workoutReducer,
      workoutData: workoutDataReducer,
    }),
    ...asyncReducers,
  });
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;
  store.asyncReducers[key] = reducer; // eslint-disable-line no-param-reassign
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};
